import { useState } from "react";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import Icon from "./Icon";
import { TRIP_COLORS } from "../utils";

export default function EditTripModal({ trip, onClose, onUpdated }) {
  const [name, setName] = useState(trip.name || "");
  const [startDate, setStartDate] = useState(trip.startDate || "");
  const [endDate, setEndDate] = useState(trip.endDate || "");
  const [color, setColor] = useState(trip.color || TRIP_COLORS[0]);
  const [notes, setNotes] = useState(trip.notes || "");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!name.trim()) return;
    setSaving(true);
    const updates = { name: name.trim(), startDate, endDate, color, notes, updatedAt: serverTimestamp() };
    await updateDoc(doc(db, "trips", trip.id), updates);
    setSaving(false);
    onUpdated?.({ ...trip, ...updates });
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <div className="modal-title">Edit trip</div>
          <button className="modal-close" onClick={onClose}><Icon name="close" size={14} /></button>
        </div>

        <div className="form-group">
          <label className="form-label">Trip name</label>
          <input
            className="form-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Start date</label>
            <input className="form-input" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">End date</label>
            <input className="form-input" type="date" value={endDate} min={startDate || undefined} onChange={(e) => setEndDate(e.target.value)} />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Notes</label>
          <textarea
            className="form-input"
            placeholder="Packing list, reminders, ideas..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            style={{ resize: "vertical", fontFamily: "inherit" }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Color</label>
          <div className="color-picker">
            {TRIP_COLORS.map((c) => (
              <div
                key={c}
                className={`color-swatch ${color === c ? "selected" : ""}`}
                style={{ background: c }}
                onClick={() => setColor(c)}
              />
            ))}
          </div>
        </div>

        <button className="submit-btn" onClick={handleSave} disabled={!name.trim() || saving}>
          {saving ? "Saving..." : "Save changes"}
        </button>
      </div>
    </div>
  );
}
